import type { TFunction } from 'i18next';

import type { CostApprovalMode, CostEstimateDecidedVia } from '../types/cost-estimate.types';

/** i18n key per approval mode ("Approved: both" / "Approved: Vertex only"). */
export const APPROVAL_MODE_LABEL_KEY: Record<CostApprovalMode, string> = {
  WITH_FALLBACK: 'costScenarios.mode.withFallback',
  VERTEX_ONLY: 'costScenarios.mode.vertexOnly',
};

/** i18n key per decision channel — the one map the card, details panel and History share. */
const DECIDED_VIA_LABEL_KEY: Record<CostEstimateDecidedVia, string> = {
  SLACK: 'costEstimate.via.slack',
  UI: 'costEstimate.via.ui',
  TIMEOUT: 'costEstimateDetail.viaTimeout',
  RUN_ENDED: 'costEstimate.via.runEnded',
};

/** How a decision was made, in words; null when none is recorded, the raw value when unknown. */
export function decidedViaLabel(
  t: TFunction<'common'>,
  via: CostEstimateDecidedVia | null,
): string | null {
  if (!via) return null;
  const key = DECIDED_VIA_LABEL_KEY[via] as string | undefined;
  return key ? t(key) : via;
}
